import { inpayEnv } from '../env';
import { inpayLocale } from '../locale';
import { WEB_DIRECT_PAYMENT_CHID, WEB_DIRECT_PAYMENT_TYPE } from '../constant';
import apiForWeb from './api-for-web';
function _createKrpcUrl(_ref) {
  var env = _ref.env,
    stampTransaction = _ref.stampTransaction,
    channelId = _ref.channelId,
    returnUrl = _ref.returnUrl;
  var param = {
    chid: channelId || WEB_DIRECT_PAYMENT_CHID,
    type: WEB_DIRECT_PAYMENT_TYPE,
    id: stampTransaction.direct_payment_token,
    env: env
  };
  if (returnUrl) param.returnUrl = returnUrl;
  var query = apiForWeb.queryParams({
    param: param
  });
  var diPayUrl = inpayEnv.DIRECT_PAYMENT_API_ADDRESS;
  return "".concat(diPayUrl, "?").concat(query);
}
function _createJppcUrl(_ref2) {
  var env = _ref2.env,
    stampTransaction = _ref2.stampTransaction;
  var isLiveEnv = env === inpayEnv.ENV_ENUM.LIVE || env === inpayEnv.ENV_ENUM.PRE; // JPPC PRE 환경도 live를 바라봄

  var param = {
    env: isLiveEnv ? inpayEnv.ENV_ENUM.LIVE : 'qa' //  // "live" or "qa"
  };
  var query = apiForWeb.queryParams({
    param: param
  });
  var url = stampTransaction.direct_payment_url || 'UNKNOWN_PAYMENT_URL';
  return "".concat(url, "&").concat(query); // 원본 URL이 "?token=..." 형태로 들어오기 때문에 "&"로 연결
}
function _createArenaUrl(_ref3) {
  var stampTransaction = _ref3.stampTransaction;
  return stampTransaction.direct_payment_url || 'UNKNOWN_PAYMENT_URL';
}
var diPayForWeb = {
  createUrl: function createUrl(_ref4) {
    var webToken = _ref4.webToken,
      env = _ref4.env,
      stampTransaction = _ref4.stampTransaction,
      channelId = _ref4.channelId,
      returnUrl = _ref4.returnUrl;
    var market = inpayLocale.getMarketFromWebToken(webToken);
    switch (market) {
      case inpayLocale.MARKET_ENUM.KRPC:
        return _createKrpcUrl({
          env: env,
          stampTransaction: stampTransaction,
          channelId: channelId,
          returnUrl: returnUrl
        });
      case inpayLocale.MARKET_ENUM.JPPC:
        return _createJppcUrl({
          env: env,
          stampTransaction: stampTransaction
        });
      default:
        return _createArenaUrl({
          stampTransaction: stampTransaction
        });
    }
  }
};
export default diPayForWeb;